import { updateObject } from "./utility";
import {
  REINIT_NOTIFICATION,
  SUCCESS_NOTIFICATION_MESSAGE,
  ERROR_NOTIFICATION_MESSAGE,
} from "../constants";

const initialState = {
  message: "",
  type: "",
};

const NotificationAlert = (state = initialState, action) => {
  switch (action.type) {
    case REINIT_NOTIFICATION:
      return updateObject(state, initialState);
    case SUCCESS_NOTIFICATION_MESSAGE:
      return updateObject(state, {
        type: "success",
        message: action.message,
      });
    case ERROR_NOTIFICATION_MESSAGE:
      return updateObject(state, { type: "error", message: action.message });

    default:
      return state;
  }
};

export default NotificationAlert;
